import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, FileManager } from "../../Constant";
import FileSideBar from "./FileSideBar";
import FileContent from "./FileContent";

const FileManagerContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={FileManager} parent={Apps} title={FileManager} />
      <Container fluid>
        <Row>
          <FileSideBar />
          <Col xl="9" md="12" className="box-col-70">
            <div className="file-content">
              <FileContent />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FileManagerContainer;
